import { render, staticRenderFns } from "./AssessmentWizard.vue?vue&type=template&id=d0205046&scoped=true&"
import script from "./AssessmentWizard.vue?vue&type=script&lang=js&"
export * from "./AssessmentWizard.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentWizard.vue?vue&type=style&index=0&id=d0205046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0205046",
  null
  
)

export default component.exports